import React from 'react';
import { hu } from 'date-fns/locale';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';

const MONTHS = [
  'Január',
  'Feburár',
  'Március',
  'Április',
  'Május',
  'Június',
  'Július',
  'Augusztus',
  'Szeptember',
  'Október',
  'November',
  'December'
];

const WEEKDAYS_L = [
  'Vasárnap',
  'Hétfő',
  'Kedd',
  'Szerda',
  'Csütörtök',
  'Péntek',
  'Szombat'
];

const WEEKDAYS_S = [
  'V',
  'H',
  'K',
  'Sze',
  'Cs',
  'P',
  'Szo'
];

export default function Hungarian(props) {
  return (
    <DayPicker
      locale={hu}
      months={MONTHS}
      weekdaysLong={WEEKDAYS_L}
      weekdaysShort={WEEKDAYS_S}
      firstDayOfWeek={1}
      {...props}
    />
  )
}